import { useCsrVm } from "@/hooks/common/useCsrVm";
import { useParentEl } from "@/hooks/common/useParentEl";
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
import { __CLASS_FORM_PANEL__, __CLASS_FORM_PANEL_GROUP__, __CLASS_FORM_PANEL_TITLE__ } from "@/const/ssrClass";
import { useHump } from "@/hooks/common/useUtils";
import { __FIELD_TYPE_CHECKBOX__ } from "@/const/fieldType";

// 获取当前表单下所有csr组件的状态
export const useFormV3Validator = async (currentFormV3ChildrenState) => {
    const validatorArr = [];
    Object.keys(currentFormV3ChildrenState).forEach(id => {
      const vm = useCsrVm(id).$refs[id];
      vm.validator && validatorArr.push(vm.validator());
    });
    try {
        const values = {};
        const states = {}; // 对应值的映射关系
        const labelStates = {};// 以field的label为key，值为states；如果是panel，则以panel的title为key，为空就用data-type
        (await Promise.all(validatorArr)).forEach(item => {
            const { id, value, el, conf, prependValue="" } = item;
            const { dataset } = el;
            const { cmp } = dataset;
            const panel = useParentEl(el, __CLASS_FORM_PANEL__);
            const key = useHump(cmp);
            let tempValue = value;
            // panel中的field需清洗为数组对象数据
            if (panel) {
                const allGroups = panel.querySelectorAll(`.${__CLASS_FORM_PANEL_GROUP__}`);
                const group = useParentEl(el, __CLASS_FORM_PANEL_GROUP__);
                const idx = [].indexOf.call(allGroups, group); // 当前field存在panel中group的索引
                const { type } = panel.dataset;
                const title = panel.querySelector(`.${__CLASS_FORM_PANEL_TITLE__}`)?.innerHTML || type;

                // 初始化panel数组
                if (!values[type]) {
                    values[type] = [];
                    states[type] = [];
                    labelStates[type] = {
                        label: title,
                        value: [],
                    };
                }
                // 初始化panel中对应索引group对象
                if (!values[type][idx]) {
                    values[type][idx] = {};
                    states[type][idx] = {};
                    labelStates[type].value[idx] = {};
                }
                tempValue = value && prependValue ? prependValue + value : value;//
                values[type][idx][key] = tempValue; // 赋值
                states[type][idx][key] = {
                    id,
                    value: tempValue,
                    conf,
                    cmp,
                    prependValue
                }; // 赋值
                labelStates[type].value[idx][key] = {
                    label: conf.label,
                    value: tempValue,
                }; // 赋值
            }
            // 普通field直接赋值
            else {
                tempValue = value && prependValue ? prependValue + value : value;
                values[key] = tempValue;
                states[key] = {
                    id,
                    value: tempValue,
                    conf,
                    cmp,
                    prependValue
                };
                labelStates[key] = {
                    label: conf.label,
                    value: tempValue,
                };
            }
        })
        return Promise.resolve({
            values,
            states,
            labelStates,
        });
    } catch (err) {
        // checkbox 不需要弹窗提示
        if (err && err.conf && err.conf.fieldType && err.conf.fieldType !== __FIELD_TYPE_CHECKBOX__) {
            useFailMsgBox(err.conf.errorMsg);
        }
        return Promise.reject(err);
    }
}